import { render, staticRenderFns } from "./MeetingListDetails.vue?vue&type=template&id=f196e034&scoped=true&"
import script from "./MeetingListDetails.vue?vue&type=script&lang=js&"
export * from "./MeetingListDetails.vue?vue&type=script&lang=js&"
import style0 from "./MeetingListDetails.vue?vue&type=style&index=0&id=f196e034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f196e034",
  null
  
)

export default component.exports